// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/account/mobile_account.proto" (package "base.account", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MobileAccountService } from "./mobile_account";
import type { CheckPasswordExistByClientResponse } from "./mobile_account";
import type { CheckPasswordExistByClientRequest } from "./mobile_account";
import type { ActivateAccountByMobileNumberAndCaptchaResponse } from "./mobile_account";
import type { ActivateAccountByMobileNumberAndCaptchaRequest } from "./mobile_account";
import type { ResetMobileAccountPasswordByOriginalPasswordRequest } from "./mobile_account";
import type { ResetMobileAccountPasswordByTokenRequest } from "./mobile_account";
import type { ResetPasswordResponse } from "./account";
import type { ResetMobileAccountPasswordRequest } from "./mobile_account";
import type { GetMobileNumberPageByAppIdResponse } from "./mobile_account";
import type { GetMobileNumberPageByAppIdRequest } from "./mobile_account";
import type { GetMobileNumberPageByAccountsResponse } from "./mobile_account";
import type { GetMobileNumberPageByAccountsRequest } from "./mobile_account";
import type { GetByCreateTimestampBetweenResponse } from "./mobile_account";
import type { GetByCreateTimestampBetweenRequest } from "./mobile_account";
import type { GetByMobileNumberContainsResponse } from "./mobile_account";
import type { GetByMobileNumberContainsRequest } from "./mobile_account";
import type { GetCreationTimestampByAccountIdsResponse } from "./mobile_account";
import type { GetCreationTimestampByAccountIdsRequest } from "./mobile_account";
import type { BindingAccountIdForMobileNumberResponse } from "./mobile_account";
import type { BindingAccountIdForMobileNumberRequest } from "./mobile_account";
import type { CheckMobileNumberExistenceResponse } from "./mobile_account";
import type { CheckMobileNumberExistenceRequest } from "./mobile_account";
import type { GetMobileNumberByAccountsResponse } from "./mobile_account";
import type { GetMobileNumberByAccountsRequest } from "./mobile_account";
import type { LoginByCaptchaResponse } from "./mobile_account";
import type { LoginByCaptchaRequest } from "./mobile_account";
import type { LoginByPasswordResponse } from "./mobile_account";
import type { LoginByPasswordRequest } from "./mobile_account";
import type { IsRegisteredResponse } from "./mobile_account";
import type { IsRegisteredRequest } from "./mobile_account";
import type { GetAccountIdResponse } from "./mobile_account";
import type { GetAccountIdRequest } from "./mobile_account";
import type { RegisterResponse } from "./mobile_account";
import type { RegisterRequest } from "./mobile_account";
import type { RegisterByCaptchaResponse } from "./mobile_account";
import type { RegisterByCaptchaRequest } from "./mobile_account";
import type { SetPasswordForMobileResponse } from "./mobile_account";
import type { SetPasswordForMobileRequest } from "./mobile_account";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RegisterByPasswordResponse } from "./mobile_account";
import type { RegisterByPasswordRequest } from "./mobile_account";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * 手机帐号服务
 *
 * @generated from protobuf service base.account.MobileAccountService
 */
export interface IMobileAccountServiceClient {
    /**
     * 密码注册
     *
     * @generated from protobuf rpc: RegisterByPassword
     */
    registerByPassword(input: RegisterByPasswordRequest, options?: RpcOptions): UnaryCall<RegisterByPasswordRequest, RegisterByPasswordResponse>;
    /**
     * 为电话设置密码
     *
     * @generated from protobuf rpc: SetPasswordForMobile
     */
    setPasswordForMobile(input: SetPasswordForMobileRequest, options?: RpcOptions): UnaryCall<SetPasswordForMobileRequest, SetPasswordForMobileResponse>;
    /**
     * 验证码注册
     *
     * @generated from protobuf rpc: RegisterByCaptcha
     */
    registerByCaptcha(input: RegisterByCaptchaRequest, options?: RpcOptions): UnaryCall<RegisterByCaptchaRequest, RegisterByCaptchaResponse>;
    /**
     * 预注册模块
     *
     * @generated from protobuf rpc: Register
     */
    register(input: RegisterRequest, options?: RpcOptions): UnaryCall<RegisterRequest, RegisterResponse>;
    /**
     * 内部调用，根据手机号码获取 AccountId，用于关联登录账号。
     * TODO 添加系统模块调用权限。
     *
     * @generated from protobuf rpc: GetAccountId
     */
    getAccountId(input: GetAccountIdRequest, options?: RpcOptions): UnaryCall<GetAccountIdRequest, GetAccountIdResponse>;
    /**
     * 验证注册
     *
     * @generated from protobuf rpc: IsRegistered
     */
    isRegistered(input: IsRegisteredRequest, options?: RpcOptions): UnaryCall<IsRegisteredRequest, IsRegisteredResponse>;
    /**
     * 密码登录
     *
     * @generated from protobuf rpc: LoginByPassword
     */
    loginByPassword(input: LoginByPasswordRequest, options?: RpcOptions): UnaryCall<LoginByPasswordRequest, LoginByPasswordResponse>;
    /**
     * 验证码登录
     *
     * @generated from protobuf rpc: LoginByCaptcha
     */
    loginByCaptcha(input: LoginByCaptchaRequest, options?: RpcOptions): UnaryCall<LoginByCaptchaRequest, LoginByCaptchaResponse>;
    /**
     * 根据accountId获取手机号码
     *
     * @generated from protobuf rpc: GetMobileNumberByAccounts
     */
    getMobileNumberByAccounts(input: GetMobileNumberByAccountsRequest, options?: RpcOptions): UnaryCall<GetMobileNumberByAccountsRequest, GetMobileNumberByAccountsResponse>;
    /**
     * 根据access Token查看有无相应的用户
     *
     * @generated from protobuf rpc: CheckMobileNumberExistence
     */
    checkMobileNumberExistence(input: CheckMobileNumberExistenceRequest, options?: RpcOptions): UnaryCall<CheckMobileNumberExistenceRequest, CheckMobileNumberExistenceResponse>;
    /**
     * 为accountId绑定上手机号码
     *
     * @generated from protobuf rpc: BindingAccountIdForMobileNumber
     */
    bindingAccountIdForMobileNumber(input: BindingAccountIdForMobileNumberRequest, options?: RpcOptions): UnaryCall<BindingAccountIdForMobileNumberRequest, BindingAccountIdForMobileNumberResponse>;
    /**
     * @generated from protobuf rpc: GetCreationTimestampByAccountIds
     */
    getCreationTimestampByAccountIds(input: GetCreationTimestampByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetCreationTimestampByAccountIdsRequest, GetCreationTimestampByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: GetByMobileNumberContains
     */
    getByMobileNumberContains(input: GetByMobileNumberContainsRequest, options?: RpcOptions): UnaryCall<GetByMobileNumberContainsRequest, GetByMobileNumberContainsResponse>;
    /**
     * @generated from protobuf rpc: GetByCreateTimestampBetween
     */
    getByCreateTimestampBetween(input: GetByCreateTimestampBetweenRequest, options?: RpcOptions): UnaryCall<GetByCreateTimestampBetweenRequest, GetByCreateTimestampBetweenResponse>;
    /**
     * @generated from protobuf rpc: GetMobileNumberPageByAccounts
     */
    getMobileNumberPageByAccounts(input: GetMobileNumberPageByAccountsRequest, options?: RpcOptions): UnaryCall<GetMobileNumberPageByAccountsRequest, GetMobileNumberPageByAccountsResponse>;
    /**
     * @generated from protobuf rpc: GetMobileNumberPageByAppId
     */
    getMobileNumberPageByAppId(input: GetMobileNumberPageByAppIdRequest, options?: RpcOptions): UnaryCall<GetMobileNumberPageByAppIdRequest, GetMobileNumberPageByAppIdResponse>;
    /**
     * 重置密码
     *
     * @generated from protobuf rpc: ResetMobileAccountPassword
     */
    resetMobileAccountPassword(input: ResetMobileAccountPasswordRequest, options?: RpcOptions): UnaryCall<ResetMobileAccountPasswordRequest, ResetPasswordResponse>;
    /**
     * 重置密码
     *
     * @generated from protobuf rpc: ResetMobileAccountPasswordByToken
     */
    resetMobileAccountPasswordByToken(input: ResetMobileAccountPasswordByTokenRequest, options?: RpcOptions): UnaryCall<ResetMobileAccountPasswordByTokenRequest, ResetPasswordResponse>;
    /**
     * 根据原密码修改密码
     *
     * @generated from protobuf rpc: ResetMobileAccountPasswordByOriginalPassword
     */
    resetMobileAccountPasswordByOriginalPassword(input: ResetMobileAccountPasswordByOriginalPasswordRequest, options?: RpcOptions): UnaryCall<ResetMobileAccountPasswordByOriginalPasswordRequest, ResetPasswordResponse>;
    /**
     * 根据手机号激活账户
     *
     * @generated from protobuf rpc: ActivateAccountByMobileNumberAndCaptcha
     */
    activateAccountByMobileNumberAndCaptcha(input: ActivateAccountByMobileNumberAndCaptchaRequest, options?: RpcOptions): UnaryCall<ActivateAccountByMobileNumberAndCaptchaRequest, ActivateAccountByMobileNumberAndCaptchaResponse>;
    /**
     * 根据手机号查看密码是否存在
     *
     * @generated from protobuf rpc: CheckPasswordExistByClient
     */
    checkPasswordExistByClient(input: CheckPasswordExistByClientRequest, options?: RpcOptions): UnaryCall<CheckPasswordExistByClientRequest, CheckPasswordExistByClientResponse>;
}
/**
 * 手机帐号服务
 *
 * @generated from protobuf service base.account.MobileAccountService
 */
export class MobileAccountServiceClient implements IMobileAccountServiceClient, ServiceInfo {
    typeName = MobileAccountService.typeName;
    methods = MobileAccountService.methods;
    options = MobileAccountService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * 密码注册
     *
     * @generated from protobuf rpc: RegisterByPassword
     */
    registerByPassword(input: RegisterByPasswordRequest, options?: RpcOptions): UnaryCall<RegisterByPasswordRequest, RegisterByPasswordResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RegisterByPasswordRequest, RegisterByPasswordResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 为电话设置密码
     *
     * @generated from protobuf rpc: SetPasswordForMobile
     */
    setPasswordForMobile(input: SetPasswordForMobileRequest, options?: RpcOptions): UnaryCall<SetPasswordForMobileRequest, SetPasswordForMobileResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetPasswordForMobileRequest, SetPasswordForMobileResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 验证码注册
     *
     * @generated from protobuf rpc: RegisterByCaptcha
     */
    registerByCaptcha(input: RegisterByCaptchaRequest, options?: RpcOptions): UnaryCall<RegisterByCaptchaRequest, RegisterByCaptchaResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RegisterByCaptchaRequest, RegisterByCaptchaResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 预注册模块
     *
     * @generated from protobuf rpc: Register
     */
    register(input: RegisterRequest, options?: RpcOptions): UnaryCall<RegisterRequest, RegisterResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RegisterRequest, RegisterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 内部调用，根据手机号码获取 AccountId，用于关联登录账号。
     * TODO 添加系统模块调用权限。
     *
     * @generated from protobuf rpc: GetAccountId
     */
    getAccountId(input: GetAccountIdRequest, options?: RpcOptions): UnaryCall<GetAccountIdRequest, GetAccountIdResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountIdRequest, GetAccountIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 验证注册
     *
     * @generated from protobuf rpc: IsRegistered
     */
    isRegistered(input: IsRegisteredRequest, options?: RpcOptions): UnaryCall<IsRegisteredRequest, IsRegisteredResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<IsRegisteredRequest, IsRegisteredResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 密码登录
     *
     * @generated from protobuf rpc: LoginByPassword
     */
    loginByPassword(input: LoginByPasswordRequest, options?: RpcOptions): UnaryCall<LoginByPasswordRequest, LoginByPasswordResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<LoginByPasswordRequest, LoginByPasswordResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 验证码登录
     *
     * @generated from protobuf rpc: LoginByCaptcha
     */
    loginByCaptcha(input: LoginByCaptchaRequest, options?: RpcOptions): UnaryCall<LoginByCaptchaRequest, LoginByCaptchaResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<LoginByCaptchaRequest, LoginByCaptchaResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据accountId获取手机号码
     *
     * @generated from protobuf rpc: GetMobileNumberByAccounts
     */
    getMobileNumberByAccounts(input: GetMobileNumberByAccountsRequest, options?: RpcOptions): UnaryCall<GetMobileNumberByAccountsRequest, GetMobileNumberByAccountsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMobileNumberByAccountsRequest, GetMobileNumberByAccountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据access Token查看有无相应的用户
     *
     * @generated from protobuf rpc: CheckMobileNumberExistence
     */
    checkMobileNumberExistence(input: CheckMobileNumberExistenceRequest, options?: RpcOptions): UnaryCall<CheckMobileNumberExistenceRequest, CheckMobileNumberExistenceResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckMobileNumberExistenceRequest, CheckMobileNumberExistenceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 为accountId绑定上手机号码
     *
     * @generated from protobuf rpc: BindingAccountIdForMobileNumber
     */
    bindingAccountIdForMobileNumber(input: BindingAccountIdForMobileNumberRequest, options?: RpcOptions): UnaryCall<BindingAccountIdForMobileNumberRequest, BindingAccountIdForMobileNumberResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<BindingAccountIdForMobileNumberRequest, BindingAccountIdForMobileNumberResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCreationTimestampByAccountIds
     */
    getCreationTimestampByAccountIds(input: GetCreationTimestampByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetCreationTimestampByAccountIdsRequest, GetCreationTimestampByAccountIdsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCreationTimestampByAccountIdsRequest, GetCreationTimestampByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetByMobileNumberContains
     */
    getByMobileNumberContains(input: GetByMobileNumberContainsRequest, options?: RpcOptions): UnaryCall<GetByMobileNumberContainsRequest, GetByMobileNumberContainsResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetByMobileNumberContainsRequest, GetByMobileNumberContainsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetByCreateTimestampBetween
     */
    getByCreateTimestampBetween(input: GetByCreateTimestampBetweenRequest, options?: RpcOptions): UnaryCall<GetByCreateTimestampBetweenRequest, GetByCreateTimestampBetweenResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetByCreateTimestampBetweenRequest, GetByCreateTimestampBetweenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetMobileNumberPageByAccounts
     */
    getMobileNumberPageByAccounts(input: GetMobileNumberPageByAccountsRequest, options?: RpcOptions): UnaryCall<GetMobileNumberPageByAccountsRequest, GetMobileNumberPageByAccountsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMobileNumberPageByAccountsRequest, GetMobileNumberPageByAccountsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetMobileNumberPageByAppId
     */
    getMobileNumberPageByAppId(input: GetMobileNumberPageByAppIdRequest, options?: RpcOptions): UnaryCall<GetMobileNumberPageByAppIdRequest, GetMobileNumberPageByAppIdResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMobileNumberPageByAppIdRequest, GetMobileNumberPageByAppIdResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 重置密码
     *
     * @generated from protobuf rpc: ResetMobileAccountPassword
     */
    resetMobileAccountPassword(input: ResetMobileAccountPasswordRequest, options?: RpcOptions): UnaryCall<ResetMobileAccountPasswordRequest, ResetPasswordResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResetMobileAccountPasswordRequest, ResetPasswordResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 重置密码
     *
     * @generated from protobuf rpc: ResetMobileAccountPasswordByToken
     */
    resetMobileAccountPasswordByToken(input: ResetMobileAccountPasswordByTokenRequest, options?: RpcOptions): UnaryCall<ResetMobileAccountPasswordByTokenRequest, ResetPasswordResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResetMobileAccountPasswordByTokenRequest, ResetPasswordResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据原密码修改密码
     *
     * @generated from protobuf rpc: ResetMobileAccountPasswordByOriginalPassword
     */
    resetMobileAccountPasswordByOriginalPassword(input: ResetMobileAccountPasswordByOriginalPasswordRequest, options?: RpcOptions): UnaryCall<ResetMobileAccountPasswordByOriginalPasswordRequest, ResetPasswordResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResetMobileAccountPasswordByOriginalPasswordRequest, ResetPasswordResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据手机号激活账户
     *
     * @generated from protobuf rpc: ActivateAccountByMobileNumberAndCaptcha
     */
    activateAccountByMobileNumberAndCaptcha(input: ActivateAccountByMobileNumberAndCaptchaRequest, options?: RpcOptions): UnaryCall<ActivateAccountByMobileNumberAndCaptchaRequest, ActivateAccountByMobileNumberAndCaptchaResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActivateAccountByMobileNumberAndCaptchaRequest, ActivateAccountByMobileNumberAndCaptchaResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 根据手机号查看密码是否存在
     *
     * @generated from protobuf rpc: CheckPasswordExistByClient
     */
    checkPasswordExistByClient(input: CheckPasswordExistByClientRequest, options?: RpcOptions): UnaryCall<CheckPasswordExistByClientRequest, CheckPasswordExistByClientResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckPasswordExistByClientRequest, CheckPasswordExistByClientResponse>("unary", this._transport, method, opt, input);
    }
}
